import { defineComponent } from "vue";

const TextInput = defineComponent({
  name: "text-input",
  props: {
    name: String,
    label: String,
    type: {
      type: String,
      default: "text",
    },
    modifier: {
      type: String,
      default: "default",
    },
    autocorrect: Boolean,
    autocapitalize: Boolean,
    initialValueGetter: Function,
    placeholder: String,
    ariaLabelledby: String,
    error: String,
    required: Boolean,
    validateMethod: Function,
    srOnly: Boolean,
  },
  data() {
    let inputValue = "";

    if (
      this.initialValueGetter &&
      typeof this.initialValueGetter.bind !== "undefined"
    ) {
      inputValue = this.initialValueGetter(this.name);
    }

    return {
      isValid: true,
      isActive: false,
      showErrorMessage: false,
      randomID: "text-input-" + Math.floor(Math.random() * 1000),
      inputValue,
    };
  },
  watch: {
    inputValue() {
      this.$emit?.("change", {
        value: this.inputValue,
        name: this.name,
      });
    },
  },
  mounted() {
    this.$emit("change", {
      value: this.inputValue,
      name: this.name,
    });

    console.log("text-input mounted", this.inputValue, this.name);
    if (this.inputValue) this.setActive();
  },
  methods: {
    validate() {
      console.log("validate", this.inputValue, this.name);
      if (this.validateMethod) {
        this.isValid = this.validateMethod({
          value: this.inputValue,
          name: this.name,
        });
      } else if (this.required && !this.inputValue) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
      return this.isValid;
    },
    setActive() {
      console.log("text-input setActive", this.inputValue, this.name);
      this.isActive = true;
    },
    unsetActive() {
      console.log("text-input unsetActive", this.inputValue, this.name);
      if (!this.inputValue) this.isActive = false;
    },
    refresh() {
      setTimeout(() => {
        this.inputValue = this.$refs?.input?.value;
        if (this.inputValue) this.setActive();
      }, 0);
    },
  },
  template: `
  <div class="text-input" :class="'text-input--'+modifier">
    <div class="text-input__wrapper">
      <label
        :for="randomID"
        v-if="label || modifier === 'default' || modifier === 'newsletter'"
        :class="['text-input__label', {'is-active': isActive, 'h5': modifier === ('default' || 'label'), 'p2': modifier === 'newsletter', 'sr-only': srOnly}]">
        {{(label ? label : placeholder)}}
      </label>
      <input
        ref="input"
        class="text-input__el p1"
        :id="randomID"
        :class="{'text-input__el--error': !isValid}"
        :type="type"
        :name="name"
        :autocorrect="autocorrect"
        :autocapitalize="autocapitalize"
        :placeholder="placeholder"
        :value="inputValue"
        v-on:input="inputValue = $event.target.value"
        v-on:focus="setActive"
        v-on:blur="unsetActive" />
    </div>
    <transition name="fade">
      <p v-if="!isValid" class="text-input__error red">{{error}}</p>
    </transition>
  </div>`,
});

export default TextInput;
